import React, {useCallback, useEffect, useState} from "react";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-day-picker/dist/style.css";
import {MunshiMenu} from "../components/Menu";
import {PickDate} from "../components/Select/DateSelect";
import CashTools from "../components/CashBook/CashTools";
import {v4 as uuidv4} from "uuid";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import {ToJsDate, ToMySqlDate} from "../utilities/ToMySqlDate";
import {axiosInstance} from "../utilities/AxiosConfig";
import {ToastContainer} from 'react-toastify';
import 'primereact/resources/themes/md-light-deeppurple/theme.css'
import dayjs from "dayjs";
import Cookies from "js-cookie";
import {Scanner} from "../components/Image/ImageUtils";
import {useSpinner} from "../context/SpinnerContext";
import {notify} from "../components/toast";
import {numberWithCommas, sF} from "../utilities/NumberFormatter";

import {CashBookPrint} from "../print/CashBookPrint";
import {generateRandomString} from "../utilities/randomGenerator";
import '../App.css';

import {CashComponent} from "../components/CashBook/CashComponent";

import {Auths} from "../utilities/getAuthDep";


export function CashBook({handle}) {

    const [cashInHand, setCashInHand] = useState(0);
    const [chequeInHand, setChequeInHand] = useState(0);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [selectedRow, setSelectedRow] = useState(0);
    const [enableGlobalEdit, setEnableGlobalEdit] = useState(true);
    const [data, setData] = useState(null);
    const [postInHand, setPostInHand] = useState(0);
    const [currentCash, setCurrentCash] = useState(0);
    const [currentCheque, setCurrentCheque] = useState(0);
    const [currentPost, setCurrentPost] = useState(0);
    const [showImage, setShowImage] = useState(false);
    const [invNumber, setInvNumber] = useState(0);
    //   const [customerList, setCustomerList] = useState([])

    //   const [departmentList, setDepartmentList] = useState([])
    const [locationList, setLocationList] = useState([])
    const [departmentList, setDepartmentList] = useState([])
    const [bioData, setBioData] = useState([])

    const [customerList, setCustomerList] = useState([])
    const [printOn, setPrintOn] = useState(false);
    const [user, setUser] = useState();
    const [level] = useState(Auths);
    const [database, setDatabase] = useState();
    const {loading, setLoading} = useSpinner()
    const [tableFooter, setTableFooter] = useState(null)


    const [refreshData, setRefreshData] = useState(false);


    useEffect(() => {

        setUser(Cookies.get('user') );
        setDatabase(Cookies.get('database') );
    }, [])
    useEffect((date) => {
        setSelectedDate(dayjs(date))
    }, [setSelectedDate])

    useEffect(() => {
        setLoading(true)
        const initialData = async () => {
            await axiosInstance.get(`department`).then((response) => {
                setDepartmentList(response.data)
            }).catch((error) => {
                    notify(error.message, "error")
                }
            )
            await axiosInstance.get(`biodata/`,).then((response) => {
                setBioData(response.data)
            }).catch((error) => {
                    notify(error.message, "error")
                }
            )

            await  axiosInstance.get("customer"
            ).then((response) => {
                setCustomerList(response.data)
            }).catch((error) => {
                notify(error.message,"error")
            })

        }
        initialData().then(setLoading(false))
    }, []);
    const setPrint = () => {
        CashBookPrint(data, bioData.name, ToMySqlDate(dayjs(selectedDate)))
    }
    useEffect(() => {
        const loadData = async () => {
            try {
                let res
                const url1 = `cashBook/cashinhand/${ToMySqlDate(selectedDate)}`
                setLoading(true)
                res = await axiosInstance.get(url1)
                if (res) {
                    setCashInHand(sF(res.data))
                    setCurrentCash(sF(res.data))
                } else {
                    setCashInHand(0)
                    setCurrentCash(0)
                }
                const url2 = `cashBook/chqinhand/${ToMySqlDate(selectedDate)}`
                res = await axiosInstance.get(url2)
                if (res) {
                    setChequeInHand(sF(res.data))
                    setCurrentCheque(sF(res.data))
                } else {
                    setChequeInHand(0)
                    setCurrentCheque(0)
                }

                const url3 = `cashBook/postinhand/${ToMySqlDate(selectedDate)}`
                setLoading(true)
                res = await axiosInstance.get(url3)
                if (res) {
                    setPostInHand(sF(res.data))
                    setCurrentPost(sF(res.data))
                } else {
                    setPostInHand(0)
                    setCurrentPost(0)
                }

                const dt = ToMySqlDate(selectedDate)
                const url = `cashBook/date/${dt}`;
                setLoading(true)
                res = await axiosInstance.get(url)
                if (res && res.data.length > 0) {
                    const __data = res.data.map(item => (
                            {
                                id: generateRandomString(5),
                                invoiceId: item.invoiceId,
                                hide: false,
                                instrument: item.mode === "CHEQ" ? "CHEQUE" : item.mode,
                                posted: item.posted === 1,
                                postDate: dayjs(item.postDate) || selectedDate,
                                pending: item.pending === 1,
                                credit: sF(item.credit),
                                debit: sF(item.debit),
                                customerName: item.customerName,
                                customerId: Number(item.customerId),
                                departmentName: item.departmentName,
                                departmentId: Number(item.departmentId),
                                comment: item.comment,
                                condition: item.posted === 1 ? "Posted" : "Saved"
                            }
                        )
                    )
                    setData(__data)
                } else {
                    setData([])
                }
            } catch (e) {
                notify(e.message, "error")
            } finally {
                setLoading(false)

            }
        }
        loadData()
    }, [selectedDate, refreshData])


    useEffect(() => {
        if (!data || loading) return;
        const totalAmount = (data.map(it => (it.debit - it.credit)).reduce(
            (res, currentValue) => res + currentValue, 0))
        const cashAmount = (data.filter(it => it.instrument === "CASH").reduce((total, current) => total + (current.credit - current.debit), currentCash))
        const chequeAmount = (data.filter(it => it.instrument === "CHEQUE").reduce((total, current) => total + (current.credit - current.debit), currentCheque))
        const postAmount = (data.filter(it => it.instrument === "POST").reduce((total, current) => total + (current.credit - current.debit), currentPost))

        setTableFooter(
            <>
                <div className="flex flex-row justify-content-between w-full h-auto border-double pl-3 pr-3 pt-2">
                    <div className="flex flex-row justify-content-start  h-auto">
                        <h6>Total: </h6>
                        <h6>{numberWithCommas(totalAmount)}</h6>
                    </div>
                    <div className="flex flex-row justify-content-start  h-auto">
                        <h6>Cash: </h6>
                        <h6>{numberWithCommas(cashAmount)}</h6>
                    </div>
                    <div className="flex flex-row justify-content-start  h-auto">
                        <h6>Cheque: </h6>
                        <h6>{numberWithCommas(chequeAmount)}</h6>
                    </div>
                    <div className="flex flex-row justify-content-start  h-auto">
                        <h6>PDC: </h6>
                        <h6>{numberWithCommas(postAmount)}</h6>
                    </div>
                </div>
            </>
        )
    }, [data]) // calculate footer
    const doAction = useCallback((node) => {
        let newData = node.data
        if (newData.departmentName === "" || newData.customerName === "" || newData.mode === "" || newData.instrument === "") {
            notify("Please fill all the required fields", "error")
            return
        }
        switch (node.mode) {

            case "Save": {
                if (newData.customerName !== "" && newData.departmentName !== "" && newData.instrument !== "" && newData.customerId !== null) {
                    const itemToSave = newData
                    setLoading(true)
                    axiosInstance.post('cashBook/', itemToSave).then(res => {
                        if (res.data > 0) {
                            if (newData.invoiceId === 0) {
                                setInvNumber(res.data)
                            }
                            setRefreshData(!refreshData)
                            notify("Successfully saved", "success")
                        } else {
                            notify("Failed to save", "error")
                        }
                    }).catch(err => {
                        notify(err.message, "error")
                    }).finally(
                        setLoading(false)
                    )
                }
            }
                break;
            case "Post": {
                const itemToPost = newData
                if (newData.pending || !level.posting()) {
                    return
                }
                const id = itemToPost.invoiceId
                setLoading(true)
                const url = `cashBook/post/id/${id}`;
                axiosInstance.get(url).then(res => {
                    if (res.data > 0) {
                        notify("Successfully posted", "success")
                        setRefreshData(!refreshData)
                    } else {
                        notify("Failed to post", "error")
                    }
                }).catch(err => {
                    notify(err.message, "error")
                }).finally(
                    setLoading(false)
                )
            }
                break;
            case "UnPost": {
                if ( !level.posting()) {
                    return;
                }
                const id = newData.invoiceId
                setLoading(true)
                const url = `cashBook/unpost/id/${id}`;
                axiosInstance.get(url).then(res => {
                    if (res.data > 0) {
                        notify("Successfully unposted", "success")
                        setRefreshData(!refreshData)
                    } else {
                        notify("Failed to unpost", "error")
                    }
                }).catch(err => {
                    notify(err.message, "error")
                }).finally(
                    setLoading(false)
                )
            }
                break;


            default: {
                const id = newData.invoiceId
                if (id === 0) {
                    return;
                } else {
                    if (newData.posted) {
                        return;
                    }
                    setLoading(true)
                    axiosInstance.delete(`cashBook/${id}`)
                        .then((response) => {
                            if (response.data > 0) {
                                notify("Successfully deleted", "success")
                                setRefreshData(!refreshData)
                            } else {
                                notify("Failed to delete", "error")
                            }
                        }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        setLoading(false)
                    )
                }
            }
        }
    }, [data])
    if (!loading && customerList && departmentList) {
        return (
            <>
                <div className="bg-black h-screen">
                <ToastContainer/>
                {showImage ? <Scanner loading={loading} setLoading={setLoading} invoice={invNumber} mode={"CASH"}
                                      showImage={showImage} setShowImage={setShowImage}/> : null}
                <div className="flex flex-row justify-content-start  h-auto w-full pd-10">
                    <MunshiMenu handle={handle}/>
                    <CashTools setAction={setPrint} enable={enableGlobalEdit} selectedRow={selectedRow}/>
                </div>

                <CashComponent actions={(node) => doAction(node)} data={data} customerList={customerList}
                               departmentList={departmentList} selectedDate={selectedDate} invoiceNumber={invNumber}
                               setSelectedDate={setSelectedDate} setShowImage={setShowImage} setInvoiceNumber={setInvNumber} footer={tableFooter} level={level}/>
                </div>
            </>
        );
    }
}

